import { useEffect, useState } from 'react';
import { mixpanelTrack } from './asyncMixpanel';
import { MIXPANEL_EVENT } from './events';
import { usePageMetadata } from '@/hooks';

let clickCounter = 0;

const RAGE_CLICK_COUNT = 5;
const RAGE_CLICK_TIME = 750; // 5 clicks within 750ms windows

/**
 * Detect if a rage click happened.
 * This is defined if more than 4 clicks happen in 1s.
 */
export function useDetectRageClicks() {
  const { page: pageType } = usePageMetadata();
  const [initTrackRageClicks, setInitTrackRageClicks] = useState(false);

  const trackRageClick = () => {
    clickCounter++;

    if (!pageType) {
      throw new Error('Page type is required');
    }

    if (clickCounter === RAGE_CLICK_COUNT) {
      mixpanelTrack(MIXPANEL_EVENT.rageClick.detected, {
        page: pageType,
      });
    }

    setTimeout(() => clickCounter--, RAGE_CLICK_TIME);
  };

  useEffect(() => {
    if (initTrackRageClicks) {
      document.addEventListener('click', trackRageClick);
    }

    return () => {
      document.removeEventListener('click', trackRageClick);
    };
  }, [initTrackRageClicks]);

  const trackRageClicks = () => {
    if (initTrackRageClicks) {
      return;
    }

    setInitTrackRageClicks(true);
  };

  return { trackRageClicks };
}
